import {
  Badge,
  Flex,
  HStack,
  TruncateMarkup,
  Typography,
  VStack,
  Show,
} from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer';
import { capitalize } from 'shared_DEPRECATED/utils';

import { ChallengeGoalsType } from 'features/challenge/config/types';

import { Tooltip } from 'shared/components/Tooltip';
import { partitionItems } from 'shared/utils/array';

type TChallengeInfoGoalsProps = {
  goals: ChallengeGoalsType;
};

export const ChallengeInfoGoals = ({ goals }: TChallengeInfoGoalsProps) => {
  if (!goals || !goals.length) {
    return null;
  }
  const { firstItems, secondItems, remainingCount } = partitionItems(goals);

  return (
    <>
      <Spacer size="sm zr zr" />
      <Flex gap="0.25rem" flexWrap="wrap" data-testid="challenge-card-goals">
        {firstItems.map(({ goalId, title, prioritized }) => (
          <Badge
            key={goalId}
            whiteSpace="wrap"
            data-testid="challenge-card-goal"
          >
            <HStack>
              <Show when={prioritized}>
                <span data-testid="challenge-card-goal-prioritized">
                  <Icon
                    name={iconNames.flagNew}
                    fill="var(--fgInteractive)"
                    stroke="var(--fgInteractive)"
                    width="14px"
                  />
                </span>
              </Show>
              <TruncateMarkup ellipsis={<span>...</span>}>
                <span title={title} data-testid="challenge-card-goal-title">
                  {capitalize(title)}
                </span>
              </TruncateMarkup>
            </HStack>
          </Badge>
        ))}
        {remainingCount > 0 ? (
          <Tooltip
            content={
              <VStack alignItems="start">
                {secondItems.map(({ goalId, title, prioritized }) => (
                  <Badge
                    key={goalId}
                    whiteSpace="wrap"
                    colorPalette="lightGray"
                  >
                    <Typography color="white" type="small" fontWeight="medium">
                      <HStack>
                        <Show when={prioritized}>
                          <span>
                            <Icon
                              name={iconNames.flagNew}
                              fill="var(--fgInteractive)"
                              stroke="var(--fgInteractive)"
                              width="14px"
                            />
                          </span>
                        </Show>
                        <TruncateMarkup ellipsis={<span>...</span>}>
                          <span title={title}>{capitalize(title)}</span>
                        </TruncateMarkup>
                      </HStack>
                    </Typography>
                  </Badge>
                ))}
              </VStack>
            }
            positioning={{ offset: 8, placement: 'bottom-end' }}
          >
            <Badge>+{remainingCount} more</Badge>
          </Tooltip>
        ) : null}
      </Flex>
    </>
  );
};
